window.Wheels = (($, h, l, d, cl) => {

    class Wheels {

        constructor() {

            $('body')
                .on("click", '.wheelSubmit', this.proxy(this.changeAmount))
                .on("click", '.pictureZoom', this.proxy(this.pictureZoom))
                .on("click", '.pictureShowroom', this.proxy(this.pictureShowroom))
            ;

            $(".searchButton").on("click", this.proxy(this.kbaSearch));
            $('#filterForm select').on('change', this.proxy(this.loadContent));

            $( document ).ready(function() {
                $('#filterForm select:first').trigger('change');
            });
        }

        // Proxy
        proxy(func, context) {
            let _this = this;
            return function () {
                func.call(_this, this, ...arguments);
            }
        }

        changeAmount(jqThis, e) {
            e.preventDefault();
            location.href = $(jqThis).attr('href').replace('-C-', $('#'+$(jqThis).attr('id')).val());
        }

        kbaSearch(jqThis, e) {
            e.preventDefault();
            let th = $('#kbaId');
            let kbaId = th.val();
            let uri = th.data('link');

            if (kbaId != '') {
                ajax.Wheels.searchKbaNumber(
                    this.proxy(this.searchKbaNumberCallback),
                    decodeURIComponent(location.pathname) + kbaId
                );
            }

        }

        searchKbaNumberCallback(_, error, data) {

            console.log(data);
            if (data.message != '') {
                alert(data.message);
            }

            if (data.uri != '') {
                location.href = data.uri
            }
        }

        loadContent(jqThis, e) {
            let filterForm = $('#filterForm');
            let a = filterForm.find('input[name="a"]').val();

            if (filterForm.find("select[name='" + $(jqThis).attr('name') + "'] option:selected").hasClass('disabled')) {
                filterForm.find("select[name!='" + $(jqThis).attr('name') + "']").val('');
            }

            ajax.Wheels[a](
                filterForm.serialize(),
                this.proxy(this.renderOverviewCallback)
            );
        }

        renderOverviewCallback(_, error, data) {

            let ajaxContent = $('#ajaxTarget');

            //HTML updaten
            ajaxContent.html(data.html);

            // Wenn Ausgrauerdaten kommen diese verarbeiten
            if(typeof data.grey != 'undefined') {

                let filterForm = $("#filterForm");
                //Aktivfilterindikator entfernen
                filterForm.find("select").removeClass('activeFilter');

                //Ausgrauen
                filterForm.find("select option[value!='']").addClass('disabled');
                $.each(data.grey, function(i,item){

                    $.each(item, function(i2,item2){
                        filterForm.find("select[name='filter[" + i + "]'] option[value='" + item2 + "']").removeClass('disabled');
                    });

                    //Aktivfilterindikator setzen
                    let _this = $("#filterForm").find("select[name='filter[" + i + "]'] option:selected");
                    if(_this.val() != '') _this.parent().addClass('activeFilter');

                });

                // Aktualisieren der Selectboxen
                $('.selectpicker').selectpicker('refresh');

            }

        }

        pictureZoom(jqThis, e) {
            e.preventDefault();
            $('.imagePreview').attr('src', $(jqThis).parent().find('.zoomImage').attr('src').replace('150x150', '550x550'));
            $('#imagemodal').modal('show');
        }

        pictureShowroom(jqThis, e) {
            window.CI360.destroy();
            var cloudImage = $('.cloudimage-360');
            cloudImage.attr('data-folder', cdnPath + $(jqThis).data('realm')+'/');
            cloudImage.attr('data-filename', $(jqThis).data('name') + '{index}.jpg');
            cloudImage.attr('data-amount', $(jqThis).data('count'));
            cloudImage.attr('data-hide-360-logo', 'true');
            cloudImage.attr('data-autoplay', 'true');
            cloudImage.attr('data-stop-at-edges', 'true');
            cloudImage.attr('data-drag-speed', 300);
            cloudImage.attr('data-control-reverse', 'true');
            window.CI360.init();
            $('#threeSixtySpinner').modal('show');
        }

    }

    return Wheels;

})(jQuery, window.history, window.location, document, console.log);